import { useEffect } from 'react'
import Cookies from 'js-cookie'
import { useLogoutFunction, useRedirectFunctions } from '@propelauth/react'
import { TOKEN_KEY, TOKEN_REFRESH_KEY } from 'constants/app.constants'
import Column from 'components/core/Column'
import { CircularProgress } from '@mui/material'
import { DESIGN_TOKENS } from 'constants/color.constants'

export const Logout = () => {
    const logout = useLogoutFunction()
    const { redirectToLoginPage } = useRedirectFunctions()

    useEffect(() => {
        Cookies.remove(TOKEN_KEY)
        Cookies.remove(TOKEN_REFRESH_KEY)
        logout(false)
        redirectToLoginPage()
    }, [logout, redirectToLoginPage])

    return (
        <Column
            fullHeight
            fullWidth
            justifyContent="center"
            alignItems="center"
        >
            <CircularProgress
                style={{ color: DESIGN_TOKENS.text.mutedForeground }}
            />
        </Column>
    )
}
